/**
 * Returns true if the question has any answers from the current user.
 * @param {object} question - The question object from the QA API.
 * @returns {boolean} - True if the question has any answers from the current user, false otherwise.
 */
export function isQuestionWithMyAnswers(question) {
    return question.answers.mine > 0;
}
